/**
 * @fileoverview Resolves whether a violation mapping permits multiple occurrences.
 * @module inspection-renderer/violations
 *
 * Responsibilities:
 * - Apply the shared default for multi-occurrence violation capture.
 * Dependencies:
 * - @firesquirrel/core-domain ViolationMapping.
 * Architecture:
 * - Pure domain logic shared by capture dispatch and presentation.
 * Notes:
 * - Multiple occurrences are enabled unless explicitly disabled.
 */
import type { ViolationMapping } from '@firesquirrel/core-domain';

/**
 * @reusable isMultiOccurrenceAllowed
 * Usage: Use in every renderer path that decides whether a mapping can append occurrences.
 * Rules: Explicit `false` disables multiple occurrences; omitted values remain enabled.
 */
export function isMultiOccurrenceAllowed(
  mapping: Partial<Pick<ViolationMapping, 'allowMultipleInstances'>>,
): boolean {
  return mapping.allowMultipleInstances !== false;
}
